import React from 'react';
import ForgotPasswordContent from '../components/pages/user/forgot-password/content';

export default function ForgotPasswordPage(props) {
  return <ForgotPasswordContent userEmail={props.userEmail} />;
}
